import { render, staticRenderFns } from "./chip.vue?vue&type=template&id=4c238758"
import script from "./chip.vue?vue&type=script&lang=ts"
export * from "./chip.vue?vue&type=script&lang=ts"
import style0 from "./chip.vue?vue&type=style&index=0&id=4c238758&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports